import { IStore } from 'store/configureStore';
import { selectCustomFieldValuesState } from 'modules/settings/submodules/clients/customFieldValues/store/selectors';

export const selectCreateCustomFieldValueState = (state: IStore) =>
    selectCustomFieldValuesState(state).customFieldValueCreate;
export const selectIsCreateCustomFieldValueModalOpened = (state: IStore) =>
    selectCreateCustomFieldValueState(state).isOpen;
export const selectIsCreatingCustomFieldValue = (state: IStore) => selectCreateCustomFieldValueState(state).isCreating;
